import {
  Select,
  Modal,
  Flex,
  Button,
  LoadingOverlay,
  Text,
  Box,
  Stack,
  Loader,
  Group,
  ScrollArea,
  HoverCard,
  UnstyledButton
} from "@mantine/core";
import { DatePickerInput } from '@mantine/dates';
import {
  IconChevronDown, IconX, IconCheck, IconAlertTriangle
} from "@tabler/icons-react";
import { notifications } from '@mantine/notifications';
import SettingsApi from "../../api/SettingsApi";
import { visiUserSession, setVisiUserSession } from '../../GeneralFunction';
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useEffect, useState, ReactNode } from 'react';
import moment from 'moment';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import GeneralComponentApi from "../../api/GeneralComponentApi";
import './GeneralComponent.css';
import { useAuth } from '../../AuthContext';

export function SelectMemberWebsiteList({ SelectMemberWebsiteListValue, SelectMemberWebsiteListOnChange, SelectMemberWebsiteListWidth, SelectMemberWebsiteListUsedIn, SelectMemberWebsiteListMaxDropdownHeight, SelectMemberWebsiteListdropdownPosition, SelectMemberWebsiteListdropdownPositionMB, SelectMemberWebsiteListML, PageType, refreshMemberWebsiteList }:any) {

  const handleMemberWebsiteChange = (e:any) => {
    SelectMemberWebsiteListOnChange(e);
    if(SelectMemberWebsiteListValue !== e){
      if(visiUserSession().page === '/reviewing-test'){
        navigate('/review-tests');
      }else if(visiUserSession().page === '/test-history-report'){
        navigate('/review-tests');
      }else if(visiUserSession().page.includes("/create-campaign")){
        navigate('/manage-campaigns');
      }else if(visiUserSession().page.includes("/campaign-report")){
        navigate('/campaign-reports');
      }else if(visiUserSession().page === "/create-heatmap" || visiUserSession().page.includes("/heatmap-view")){
        navigate('/heat-maps');
      }else if(visiUserSession().page === "/create-scrollmap" || visiUserSession().page.includes("/scrollmap-view")){
        navigate('/scroll-maps');
      }else if(visiUserSession().page === "/recording-setting" || visiUserSession().page === "/recordings-list" || visiUserSession().page === "/recording-view"){
        navigate('/recordings');
      }
    }
    if(SelectMemberWebsiteListUsedIn && SelectMemberWebsiteListUsedIn === 'HeaderMenu'){
      setVisiUserSession('website', e);
    }
  };

  const navigate = useNavigate();

  type Website = {
    website_id: string;
    website_name: string;
  }

  const [memberWebsiteList, setmemberWebsiteList] = useState<Website[]>([]);
  const { websiteListData, setWebsiteListData } = useAuth();

  useEffect(() => {
    if(websiteListData.length > 0 && PageType === undefined){
      setmemberWebsiteList(websiteListData);
      return;
    }
    GeneralComponentApi.getmemberwebsitelist({
        page_type: PageType
      })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setmemberWebsiteList(data.data);
        if(PageType === undefined){
          setWebsiteListData(data.data)
        }
        if(data.data.length > 0){
          if(refreshMemberWebsiteList && refreshMemberWebsiteList !== ''){
            const [websiteAddDeleteType, websiteAddDeleteId] = refreshMemberWebsiteList.split("__");
            if(websiteAddDeleteType === 'add'){
              SelectMemberWebsiteListOnChange(websiteAddDeleteId);
              setVisiUserSession('website', websiteAddDeleteId);
            }else if(websiteAddDeleteType === 'delete'){
              const websiteToRemove = data.data.find(website => website.website_id === websiteAddDeleteId);
              if (websiteToRemove) {
                const updatedData = data.filter(website => website.website_id !== websiteAddDeleteId);
                setmemberWebsiteList(updatedData);
                setWebsiteListData(updatedData);
              }
              SelectMemberWebsiteListOnChange(data.data[0].website_id);
              setVisiUserSession('website', data.data[0].website_id);
            }
          }else{
            if(visiUserSession() && visiUserSession().website && visiUserSession().website !== ''){
              if(SelectMemberWebsiteListUsedIn === 'HeaderMenu'){
                if (Array.isArray(data.data) && data.data.some(item => item.website_id === visiUserSession().website)) {
                   SelectMemberWebsiteListOnChange(visiUserSession().website);
                }else{
                  SelectMemberWebsiteListOnChange(data.data[0].website_id);
                  setVisiUserSession('website', data.data[0].website_id);
                }
              }
            }else{
              if(SelectMemberWebsiteListUsedIn === 'HeaderMenu'){
                SelectMemberWebsiteListOnChange(data.data[0].website_id);
                setVisiUserSession('website', data.data[0].website_id); 
              }
            }
          }
        }
      }
    })
    .catch(error => {
      console.log(error);
    });

  }, [refreshMemberWebsiteList]);

  useEffect(() => {
    if(memberWebsiteList.length > 0){
      if(visiUserSession() && visiUserSession().website && visiUserSession().website !== ''){
        SelectMemberWebsiteListOnChange(visiUserSession().website);
      }else{
        if(websiteListData && websiteListData.length > 0){
          SelectMemberWebsiteListOnChange(websiteListData[0].website_id);
          setVisiUserSession('website', websiteListData[0].website_id);
        }else{
          if(SelectMemberWebsiteListUsedIn === 'HeaderMenu'){
            SelectMemberWebsiteListOnChange(memberWebsiteList[0].website_id);
            setVisiUserSession('website', memberWebsiteList[0].website_id);
          }
        }
      }
    }
  }, [memberWebsiteList]);

  return (
    <>
      <Select
        rightSection={<IconChevronDown size="1rem" />}
        rightSectionWidth={30}
        styles={{ rightSection: { pointerEvents: 'none' } }}
        data={memberWebsiteList.map(website => ({
            value: website.website_id,
            label: website.website_name
        }))}
        value={SelectMemberWebsiteListValue}
        onChange={handleMemberWebsiteChange}
        w={SelectMemberWebsiteListWidth}
        searchable
        maxDropdownHeight={SelectMemberWebsiteListMaxDropdownHeight}
        dropdownPosition={SelectMemberWebsiteListdropdownPosition}
        mb={SelectMemberWebsiteListdropdownPositionMB}
        ml={SelectMemberWebsiteListML}
        withinPortal
      />
    </>
  );
}

export function SelectFilterType({ SelectFilterTypeValue, SelectFilterTypeOnChange }:any) {

  const handleFilterTypeChange = (e:any) => {
    SelectFilterTypeOnChange(e);
  };

  const [filterTypeList, setfilterTypeList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    GeneralComponentApi.getfiltertypelist()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        let filterTypeListData = [];
        for(const key in data.data[0]){
          filterTypeListData.push({
            value: key, label: data.data[0][key]
          });
        }
        setfilterTypeList(filterTypeListData);
        if(data.data.length > 0){
          const filterTypeListKeys = Object.keys(data.data[0]);
          SelectFilterTypeOnChange(filterTypeListKeys[0]);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });

  }, []);

  return (
    <>
      <Select
        data={filterTypeList}
        value={SelectFilterTypeValue}
        onChange={handleFilterTypeChange}
        searchable
        withinPortal
      />
    </>
  );
}

export function SelectTimePicker({ SelectTimePickerValue, SelectTimePickerOnChange, SelectTimePickerFromDateOnChange, SelectTimePickerToDateOnChange, SelectTestStartDate, SelectTestEndDate='', SelectStartDate='', SelectedPage='' }:any) {

  const [isTimeRangeModalOpen, setIsTimeRangeModalOpen] = useState(false);
  const [FromDatevalue, setFromDateValue] = useState<Date | null>(SelectTestStartDate);
  const [ToDatevalue, setToDateValue] = useState<Date | null>(null);
  const [MinStartDateValue, setMinStartDateValue] = useState<Date | null>(null);
  const [lastSelectedValue, setLastSelectedValue] = useState(SelectTimePickerValue);
  const [displayedDropdownValue, setDisplayedDropdownValue] = useState(null);


  const handleTimePickerChange = (e:any) => {
    SelectTimePickerOnChange(e);
    setVisiUserSession('time', e);
    if(SelectedPage === "create_report"){
      const FromDate = (SelectTestStartDate) ? moment(SelectTestStartDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      const ToDate = (SelectTestEndDate) ? moment(SelectTestEndDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      setVisiUserSession('start_date', FromDate);
      setVisiUserSession('end_date', ToDate);
    }
    if(SelectedPage === "reviewing_test"){
      let endformattedDate, startFormattedDate, testStartFormattedDate = new Date();
      const FromDate = (SelectTestStartDate) ? moment(SelectTestStartDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      const ToDate = (SelectTestEndDate) ? moment(SelectTestEndDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      if(SelectTestStartDate){
        const [year, month, day] = SelectTestStartDate.split("-");
        startFormattedDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
      if(SelectTestEndDate){
        const [endYear, endMonth, endDay] = SelectTestEndDate.split("-");
        endformattedDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDay));
      }
      if(SelectStartDate){
        const [testYear, testMonth, testDate] = SelectStartDate.split("-");
        testStartFormattedDate = new Date(Number(testYear), Number(testMonth) - 1, Number(testDate));
      }
      if (startFormattedDate < testStartFormattedDate) {
        const FromTestDate = (SelectStartDate) ? moment(SelectStartDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
        if (!visiUserSession().hasOwnProperty('start_date')) {
          setVisiUserSession('start_date', FromTestDate);
        }
        setVisiUserSession('reviewing_test_start_date', FromTestDate);
      }else{
        setVisiUserSession('reviewing_test_start_date', FromDate);
        if (!visiUserSession().hasOwnProperty('start_date')) {
          setVisiUserSession('start_date', FromDate);
        }
      }
      if (endformattedDate < testStartFormattedDate) {
        const ToTestDate = moment(currentDate).format("MM-DD-YYYY");
        if (!visiUserSession().hasOwnProperty('end_date')) {
          setVisiUserSession('end_date', ToTestDate);
        }
        setVisiUserSession('reviewing_test_end_date', ToTestDate);
      }else{
        setVisiUserSession('reviewing_test_end_date', ToDate);
        if (!visiUserSession().hasOwnProperty('end_date')) {
          setVisiUserSession('end_date', ToDate);
        }
      }
    }
    if(e === -2){
      const [year, month, day] = SelectTestStartDate.split("-");
      const formattedDate = new Date(Number(year), Number(month) - 1, Number(day));
      let endformattedDate, startFormattedDate = new Date();
      if(SelectTestEndDate){
        const [endYear, endMonth, endDay] = SelectTestEndDate.split("-");
        endformattedDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDay));
      }
      if(SelectStartDate){
        const [startYear, startMonth, startDay] = SelectStartDate.split("-");
        startFormattedDate = new Date(Number(startYear), Number(startMonth) - 1, Number(startDay));
      }
      if(SelectedPage === "reviewing_test"){
        if (formattedDate < startFormattedDate) {
          setFromDateValue(startFormattedDate);
        }else{
          setFromDateValue(formattedDate);
        }
        if (endformattedDate < startFormattedDate) {
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const date = String(today.getDate()).padStart(2, '0');

          const currentFormattedDate = new Date(`${year}-${month}-${date}`);
          setToDateValue(currentFormattedDate);
        }else{
          setToDateValue(endformattedDate);
        }
      } else {
        setFromDateValue(formattedDate);
        setToDateValue(endformattedDate);
      }
      if(pagename !== 'dashboard'){
        setMinStartDateValue(startFormattedDate);
      }
      setIsTimeRangeModalOpen(true);
    }else if (e === 11) {
      SelectTimePickerOnChange(-2);
      let formattedFromDate = '' as any;
      if(SelectedPage === "reviewing_test"){
        const [startMonth, startDate, startYear] = visiUserSession().reviewing_test_start_date.split("-");
        formattedFromDate = new Date(Number(startYear), Number(startMonth) - 1, Number(startDate));
      }else{
        const [startMonth, startDate, startYear] = visiUserSession().start_date.split("-");
        formattedFromDate = new Date(Number(startYear), Number(startMonth) - 1, Number(startDate));
      }
      setFromDateValue(formattedFromDate);
      let formattedToDate = '' as any;
      if(SelectedPage === 'reviewing_test'){
        const [endMonth, endDate, endYear] = visiUserSession().reviewing_test_end_date.split("-");
        formattedToDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDate));
      }else{
        const [endMonth, endDate, endYear] = visiUserSession().end_date.split("-");
        formattedToDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDate));
      }
      setToDateValue(formattedToDate);
      if(SelectStartDate && pagename !== 'dashboard'){
        const [startYear, startMonth, startDay] = SelectStartDate.split("-");
        const startFormattedDate = new Date(Number(startYear), Number(startMonth) - 1, Number(startDay));
        setMinStartDateValue(startFormattedDate);
      }
      setIsTimeRangeModalOpen(true);
    }else{
      setLastSelectedValue(e);
      setFromDateValue(null);
      setToDateValue(null);
      SelectTimePickerFromDateOnChange("");
      SelectTimePickerToDateOnChange("");
      if (e !== -2) {
        setTimePickerList((prev) => prev.filter(item => item.value !== 11));
      }
    }
    setDisplayedDropdownValue(e);
  };

  const [TimePickerList, setTimePickerList] = useState([]);

  const navigate = useNavigate();
  let pagename = useLocation().pathname;
  useEffect(() => {
    GeneralComponentApi.gettimepicker({
      type:SelectedPage
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        let TimePickerListData = [];
        for(const key in data.data[0]){
          TimePickerListData.push({
            value: data.data[0][key]['option_value'], label: data.data[0][key]['option_name']
          });
        }
        setTimePickerList(TimePickerListData);
        if(data.data.length > 0){
          if(SelectedPage !== "create_report"){
            if(SelectedPage === "system_usage" && visiUserSession().time === undefined){
              SelectTimePickerOnChange(-3);
              setLastSelectedValue(-3);
            }else{
              if(visiUserSession().time){
                let timeValue = visiUserSession().time === 11 ? -2 : visiUserSession().time;
                if(SelectedPage !== "system_usage" && visiUserSession().time === -3){
                  timeValue = -1;
                }
                if(timeValue === -2){
                  const FromDate = SelectedPage !== "reviewing_test" ? visiUserSession().start_date : visiUserSession().hasOwnProperty('reviewing_test_start_date') ? visiUserSession().reviewing_test_start_date :
                   visiUserSession().start_date;
                  const ToDate = SelectedPage !== "reviewing_test" ? visiUserSession().end_date : visiUserSession().hasOwnProperty('reviewing_test_end_date') ? visiUserSession().reviewing_test_end_date :
                   visiUserSession().end_date;
                  const formattedDateRange = `${FromDate} - ${ToDate}`;
                  setTimePickerList((prev) => {
                    const updatedList = prev.filter((item) => item.value !== 11);
                    updatedList.push({ value: 11, label: formattedDateRange });
                    return updatedList;
                  });
                }
                SelectTimePickerOnChange(timeValue);
                setLastSelectedValue(timeValue);
                const FromStartDate = SelectedPage !== "reviewing_test" ? visiUserSession().start_date : visiUserSession().hasOwnProperty('reviewing_test_start_date') ? visiUserSession().reviewing_test_start_date :
                   visiUserSession().start_date;
                const ToStartDate = SelectedPage !== "reviewing_test" ? visiUserSession().end_date : visiUserSession().hasOwnProperty('reviewing_test_end_date') ? visiUserSession().reviewing_test_end_date :
                   visiUserSession().end_date;
                SelectTimePickerFromDateOnChange(FromStartDate);
                SelectTimePickerToDateOnChange(ToStartDate);
                let displayValue = visiUserSession().time === -2 ? 11 : visiUserSession().time;
                if(SelectedPage !== "system_usage" && visiUserSession().time === -3){
                  displayValue = -1;
                }
                setDisplayedDropdownValue(displayValue);
              }else{
                SelectTimePickerOnChange(-1);
                setLastSelectedValue(-1);
              }
            }
          }
        }
      }
    })
    .catch(error => {
      console.log(error);
    });

  }, []);

  const handleTimeRangeCloseModal = () => {
    setIsTimeRangeModalOpen(false);
    if(lastSelectedValue !== undefined && lastSelectedValue !== -2){
      setDisplayedDropdownValue(lastSelectedValue);
      setVisiUserSession('time', lastSelectedValue);
    }else{
      setDisplayedDropdownValue(11);
      setVisiUserSession('time', 11);
    }
    SelectTimePickerOnChange(lastSelectedValue);
  };
  const currentDate = moment();
  const handleDateFilterSubmit = (event:any) => {
    event.preventDefault();
    const currentDate = moment();
    const FromDate = (FromDatevalue) ? moment(FromDatevalue).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
    const ToDate = (ToDatevalue) ? moment(ToDatevalue).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
    const formattedDateRange = `${FromDate} - ${ToDate}`;
    if(SelectTimePickerValue === -2){
      SelectTimePickerFromDateOnChange(FromDate);
      SelectTimePickerToDateOnChange(ToDate);
      if(SelectedPage === 'reviewing_test'){
        setVisiUserSession('reviewing_test_start_date', FromDate);
        if (!visiUserSession().hasOwnProperty('start_date')) {
          setVisiUserSession('start_date', FromDate);
        }
        setVisiUserSession('reviewing_test_end_date', ToDate);
        if (!visiUserSession().hasOwnProperty('end_date')) {
          setVisiUserSession('end_date', ToDate);
        }
      }else{
        setVisiUserSession('start_date', FromDate);
        if (!visiUserSession().hasOwnProperty('reviewing_test_start_date')) {
          setVisiUserSession('reviewing_test_start_date', FromDate);
        }
        setVisiUserSession('end_date', ToDate);
        if (!visiUserSession().hasOwnProperty('reviewing_test_end_date')) {
          setVisiUserSession('reviewing_test_end_date', ToDate);
        }
      }
      setTimePickerList((prev) => {
        const updatedList = prev.filter((item) => item.value !== 11);
        updatedList.push({ value: 11, label: formattedDateRange });
        return updatedList;
      });
      setLastSelectedValue(-2);
      SelectTimePickerOnChange(-2);
      setDisplayedDropdownValue(11);
    }else{
      SelectTimePickerFromDateOnChange("");
      SelectTimePickerToDateOnChange("");
      setTimePickerList((prev) => prev.filter((item) => item.value !== 11));
      setLastSelectedValue(SelectTimePickerValue);
      setDisplayedDropdownValue(SelectTimePickerValue);
    }
    setIsTimeRangeModalOpen(false);
  };


  useEffect(() => {
    if(SelectedPage === "create_report" && SelectTimePickerValue === -2){
      let endformattedDate, startFormattedDate = new Date();
      if(SelectTestStartDate){
        const [year, month, day] = SelectTestStartDate.split("-");
        startFormattedDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
      if(SelectTestEndDate){
        const [endYear, endMonth, endDay] = SelectTestEndDate.split("-");
        endformattedDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDay));
      }
      setFromDateValue(startFormattedDate);
      setToDateValue(endformattedDate);
      const FromDate = (startFormattedDate) ? moment(startFormattedDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      const ToDate = (endformattedDate) ? moment(endformattedDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      const formattedDateRange = `${FromDate} - ${ToDate}`;
      setTimePickerList((prev) => {
        const updatedList = prev.filter((item) => item.value !== 11);
        updatedList.push({ value: 11, label: formattedDateRange });
        return updatedList;
      });
      setDisplayedDropdownValue(11);
    }
  }, [SelectTimePickerValue, SelectedPage])

  useEffect(() => {
    if(SelectedPage === "reviewing_test" && SelectTimePickerValue === -2 && SelectStartDate !== '' && SelectStartDate !== undefined){
      let endformattedDate, startFormattedDate, testStartFormattedDate = new Date();
      let fromTestFormattedDate = '';
      if(SelectTestStartDate){
        const [year, month, day] = SelectTestStartDate.split("-");
        startFormattedDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
      if(SelectTestEndDate){
        const [endYear, endMonth, endDay] = SelectTestEndDate.split("-");
        endformattedDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDay));
      }
      if(SelectStartDate){
        const [testYear, testMonth, testDate] = SelectStartDate.split("-");
        testStartFormattedDate = new Date(Number(testYear), Number(testMonth) - 1, Number(testDate));
        fromTestFormattedDate = moment(SelectStartDate).format("MM-DD-YYYY");
      }

      let FromDate = '' as any;
      if (startFormattedDate < testStartFormattedDate) {
        setFromDateValue(testStartFormattedDate);
        SelectTimePickerFromDateOnChange(fromTestFormattedDate);
        FromDate = (testStartFormattedDate) ? moment(testStartFormattedDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      }else{
        setFromDateValue(startFormattedDate);
        FromDate = (startFormattedDate) ? moment(startFormattedDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      }
      
      let ToDate = '' as any;
      if (endformattedDate < testStartFormattedDate) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // months are 0-based
        const date = String(today.getDate()).padStart(2, '0');

        const currentFormattedDate = new Date(`${year}-${month}-${date}`);
        setToDateValue(currentFormattedDate);
        ToDate = moment(currentDate).format("MM-DD-YYYY");
        SelectTimePickerToDateOnChange(ToDate);
      }else{
        setToDateValue(endformattedDate);
        ToDate = (endformattedDate) ? moment(endformattedDate).format("MM-DD-YYYY") : moment(currentDate).format("MM-DD-YYYY");
      }
      const formattedDateRange = `${FromDate} - ${ToDate}`;
      setTimePickerList((prev) => {
        const updatedList = prev.filter((item) => item.value !== 11);
        updatedList.push({ value: 11, label: formattedDateRange });
        return updatedList;
      });
      setDisplayedDropdownValue(11);
    }
  }, [SelectTimePickerValue, SelectedPage, SelectStartDate])

  return (
    <>
      <Modal opened={isTimeRangeModalOpen} onClose={handleTimeRangeCloseModal} trapFocus={false} title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          TIME RANGE FILTER
          <HelpTip helpId={109} />
        </div>
      }>
        <form onSubmit={handleDateFilterSubmit}>
          <DatePickerInput
            mb={10}
            popoverProps={{ withinPortal: true }}
            valueFormat="MM-DD-YYYY"
            label="From Date"
            name="from_date"
            value={FromDatevalue}
            onChange={setFromDateValue}
            maxDate={pagename === "dashboard" ? undefined : currentDate.toDate()}
            minDate={pagename.includes("heatmap-view") || pagename.includes("scrollmap-view") || pagename.includes("reviewing-test") ? MinStartDateValue : undefined}
            mx="auto"
            maw={400}
          />
          <DatePickerInput
            mb={10}
            popoverProps={{ withinPortal: true }}
            valueFormat="MM-DD-YYYY"
            label="To Date"
            name="to_date"
            value={ToDatevalue}
            onChange={setToDateValue}
            maxDate={pagename === "dashboard" ? undefined : currentDate.toDate()}
            minDate={pagename.includes("heatmap-view") || pagename.includes("scrollmap-view") || pagename.includes("reviewing-test") ? MinStartDateValue : undefined}
            mx="auto"
            maw={400}
          />
          <Flex
            justify="flex-end"
            align="flex-start"
            direction="row"
            wrap="wrap"
          >
            <Button type="submit" color="green">Filter</Button>
          </Flex>
        </form>
      </Modal>
      <Select
        withinPortal
        onChange={handleTimePickerChange}
        value={displayedDropdownValue || SelectTimePickerValue}
        data={TimePickerList}
      />
    </>
  );
}

export function SelectWebsitePages({ SelectWebsitePagesValue, SelectWebsitePagesOnChange, SelectWebsitePagesSelectedMemberWebsite }:any) {

  const handleWebsitePagesChange = (e:any) => {
    SelectWebsitePagesOnChange(e);
  };

  const navigate = useNavigate();

  let pagename = visiUserSession().page.replace("/","");
  type Page = {
    page_id: string;
    custom_title: string;
  }

  const [WebsitePages, setWebsitePages] = useState<Page[]>([]);

  useEffect(() => {
    if(SelectWebsitePagesSelectedMemberWebsite !== ''){
      const dataObject: any = {
        system_website_id: SelectWebsitePagesSelectedMemberWebsite
      };
      if (pagename === "dashboard") {
        dataObject.type = "source";
      }
      GeneralComponentApi.getwebsitepages(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setWebsitePages(data.data);
          const allPagesOption = data.data.find((page: Page) => page.custom_title === "All pages");
          if(allPagesOption){
            SelectWebsitePagesOnChange(allPagesOption.page_id);
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [SelectWebsitePagesSelectedMemberWebsite]);

  return (
    <>
      <Select
        data={WebsitePages.map(Page => ({
          value: Page.page_id,
          label: Page.custom_title
        }))}
        value={SelectWebsitePagesValue}
        onChange={handleWebsitePagesChange}
        searchable
      />
    </>
  );
}

export function VisiLoader({ VisiLoaderVisible, loaderType='' }:any) {

  const [showMessage, setShowMessage] = useState(false);
  const msgArray = [
    "Hang tight—your data is doing its morning stretches before the big performance.",
    "Crunching numbers like a pro chef dicing onions—fast, precise, and maybe with a tear or two.",
    "Loading… because epic reports take a moment to assemble.",
    "Your report is brewing—this blend takes time for maximum flavor.",
    "Your data is stuck in traffic on the Information Superhighway. We’ll clear the lanes shortly.",
    "Pulling in the freshest data… we only serve it organic, fair-trade, and optimized.",
    "Squeezing ones and zeros into meaningful insights. Almost done.",
    "Our servers are lifting heavy data… reps are almost complete.",
    "Your report is in the oven—perfectly baked insights coming soon.",
    "Running at full speed… but data is heavy, and we’re wearing ankle weights.",
    "We’re grooming your data until it’s presentation-ready. Flawless takes a sec.",
    "Knocking politely on every database door to get you the answers you need.",
    "Beaming your results from the cloud—literally. Cloud travel time varies.",
    "Turning raw data into crystal-clear clarity. Give us just a moment.",
    "All engines are go—prepping the insights launch sequence.",
    "Think of this as your report marinating for maximum flavor.",
    "Sorting through the haystack to find all your shiny data needles.",
    "Your data is putting on its best outfit—presentation matters.",
    "Collecting the last few puzzle pieces for the perfect picture.",
    "Visiopt is crafting your report with love, precision, and a dash of patience."
  ];
  const campaignnMsgArray = [
    "Spinning up your campaign—kind of like starting a rocket launch, but with less fire.",
    "Your campaign is getting its toolkit ready: tracking, testing, and a splash of magic.",
    "Setting the stage… your campaign is almost ready to steal the spotlight."
  ];
  const testsMsgArray = [
    "Your test results are warming up in the green room—ready to make their big debut.",
    "Crunching test data… because even insights need a moment to get dressed.",
    "Sorting winners, losers, and the ‘what were we thinking?’ versions. Almost there.",
    "Your results are loading—think of it as the drumroll before the reveal.",
    "Analyzing clicks, conversions, and curveballs. Insights coming right up."
  ];
  const [displayMsg, setDisplayMsg] = useState(null);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;

    if (VisiLoaderVisible && (loaderType === 'report' || loaderType === 'campaign' || loaderType === 'tests')) {
      const lengthVar = loaderType === 'report' ? msgArray : loaderType === 'campaign' ? campaignnMsgArray : testsMsgArray ;
      const randomNum = Math.floor(Math.random() * lengthVar.length);
      setDisplayMsg(lengthVar[randomNum]);
      setShowMessage(true);
      interval = setInterval(() => {
        const randomIndex = Math.floor(Math.random() * lengthVar.length);
        setDisplayMsg(lengthVar[randomIndex]);
      }, 5000);
    } else {
      setShowMessage(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [VisiLoaderVisible]);

  return (
    <>
      <LoadingOverlay
        visible={VisiLoaderVisible}
        overlayBlur={2}
        loader={
          <Stack align="center" spacing="xs">
            <Loader variant="bars" color="gray" />
            {showMessage && (
              <Text size="md" weight={700} c="#4d73e2" style={{ fontStyle: 'italic', fontSize: '1.2rem', animation: 'fadeIn 0.5s ease-in-out' }}>
                {displayMsg}
              </Text>
            )}
          </Stack>
        }
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          position: 'fixed',
          zIndex: 9999999999,
        }}
      />
    </>
  );
}

export function SelectActiveTest({ SelectActiveTestValue, SelectActiveTestOnChange, SelectActiveTestSelectedMemberWebsite, setActiveTests }:any) {

  const handleActiveTestChange = (e:any) => {
    SelectActiveTestOnChange(e);
  };

  const navigate = useNavigate();

  type Test = {
    id: string;
    value: string;
  }

  const [ActiveTest, setActiveTest] = useState<Test[]>([]);

  useEffect(() => {
    if(SelectActiveTestSelectedMemberWebsite !== ''){
      GeneralComponentApi.getdashboardactivetestdropdown({
        system_website_id: SelectActiveTestSelectedMemberWebsite
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setActiveTest(data.data);
          setActiveTests(data.data);
          if(data.data.length > 0){
            SelectActiveTestOnChange(data.data[0].id);
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [SelectActiveTestSelectedMemberWebsite]);

  return (
    <>
      <Select
        data={ActiveTest.map(Test => ({
          value: Test.id,
          label: Test.value
        }))}
        value={SelectActiveTestValue}
        onChange={handleActiveTestChange}
        searchable
      />
    </>
  );
}

export function SelectGetGoal({ SelectGetGoalValue, SelectGetGoalOnChange, SelectGetGoalSelectedMemberWebsite, SelectGetGoalSelectedActiveTestPage, SelectGetGoalSelectedGoalType }:any) {

  const handleGetGoalChange = (e:any) => {
    SelectGetGoalOnChange(e);
  };

  const navigate = useNavigate();

  type GoalType = {
    id: string;
    value: string;
  }

  const [Goal, setGoal] = useState<GoalType[]>([]);

  useEffect(() => {
    if(SelectGetGoalSelectedMemberWebsite !== '' && SelectGetGoalSelectedActiveTestPage !== '' && SelectGetGoalSelectedGoalType){
      GeneralComponentApi.getgoal({
        system_website_id: SelectGetGoalSelectedMemberWebsite,
        active_test_page_id: SelectGetGoalSelectedActiveTestPage,
        goal_type: SelectGetGoalSelectedGoalType,
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setGoal(data.data);
          if(data.data.length > 0){
            SelectGetGoalOnChange(data.data[0].id);
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [SelectGetGoalSelectedMemberWebsite, SelectGetGoalSelectedActiveTestPage, SelectGetGoalSelectedGoalType]);

  return (
    <>
      <Select
        data={Goal.map(Goal => ({
          value: Goal.id,
          label: Goal.value
        }))}
        value={SelectGetGoalValue}
        onChange={handleGetGoalChange}
        searchable
      />
    </>
  );
}

export function BoxPageThumb({ BoxPageThumbSelectedMemberWebsite, BoxPageThumbSelectedActiveTestPage }:any) {

  const navigate = useNavigate();

  const [ThumbTitle, setThumbTitle] = useState('');
  const [ThumbCustomTitle, setThumbCustomTitle] = useState('');
  const [Thumb, setThumb] = useState('');
  const [ThumbURL, setThumbURL] = useState('');

  useEffect(() => {
    if(BoxPageThumbSelectedMemberWebsite !== '' && BoxPageThumbSelectedActiveTestPage !== ''){
      GeneralComponentApi.getpagethumb({
        system_website_id: BoxPageThumbSelectedMemberWebsite,
        active_test_page_id: BoxPageThumbSelectedActiveTestPage
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          if(data){
            if(data.data.title){
              setThumbTitle(data.data.title);
            }
            if(data.data.custom_title){
              setThumbCustomTitle(data.data.custom_title);
            }
            if(data.data.thumb){
              setThumb(data.data.thumb);
            }
            if(data.data.url){
              setThumbURL(data.data.url);
            }
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [BoxPageThumbSelectedMemberWebsite, BoxPageThumbSelectedActiveTestPage, navigate]);
  return (
    <>
      <div className="visi-page">
        <div className="page">
          <a href={ThumbURL} target="_blank" rel="noopener noreferrer">
            <span className="page-url">{ThumbTitle}</span>
          </a>
          <div className="thumbnail" style={{backgroundImage : `url(${Thumb})`}}>
          </div>
          <span className="page-title">{ThumbCustomTitle}</span>
        </div>
      </div>
    </>
  );
}

export function SelectFunnelList({updated_time, Value, OnChange, MemberWebsiteId, Width, IsSelected = true, IsFieldDisabled }:any) {

  const handleFunnelListChange = (e:any) => {
    OnChange(e);
  };

  const navigate = useNavigate();

  type Funnel = {
    funnel_id: string;
    funnel_name: string;
  }

  const [funnelList, setfunnelList] = useState<Funnel[]>([]);

  useEffect(() => {
    if(MemberWebsiteId !== ''){
      GeneralComponentApi.getfunnellist({
          system_website_id: MemberWebsiteId
        })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })

      .then(data => {
        if(data.status === 1){
          setfunnelList(data.data);
          if(data.data.length > 0){
            if(IsSelected){
              var i;
              for(i = 0; i <data.data.length; i++){
                if(data.data[i].selected === 'true'){
                  OnChange(data.data[i].funnel_id);
                  break;
                }
              }
            }else{
              OnChange('');
            }
          }else{
            OnChange('');
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [MemberWebsiteId,updated_time]);
  return (
    <>
      {IsFieldDisabled === true ? ( 
        <Select
          data={funnelList.map(funnel => ({
            value: funnel.funnel_id ? funnel.funnel_id : '',
            label: funnel.funnel_name ? funnel.funnel_name : ''
          }))}
          value={Value}
          onChange={handleFunnelListChange}
          w={Width}
          searchable
          placeholder="Select a funnel"
          disabled={true}
          styles={{ input: { cursor: 'pointer' } }}
        />
      ) : ( 
        <Select
          data={funnelList.map(funnel => ({
            value: funnel.funnel_id ? funnel.funnel_id : '',
            label: funnel.funnel_name ? funnel.funnel_name : ''
          }))}
          value={Value}
          onChange={handleFunnelListChange}
          w={Width}
          searchable
          placeholder="Select a funnel"
          styles={{ input: { cursor: 'pointer' } }}
        />
      )}
    </>
  );
}

export type HelpDetails = { title: string; text: string; videoLink: string };

const toHelpDetails = (raw: any): HelpDetails | null => (raw && raw.text)
  ? { title: raw.title ?? '', text: raw.text ?? '', videoLink: String(raw.show_video) === '1' ? (raw.video_link ?? '') : '' }
  : null;

// One request per help id per session, shared by every help icon; a failed load is retried on the next hover.
const helpDetailsCache = new Map<number, Promise<HelpDetails | null>>();
export const loadHelpDetails = (helpId: number): Promise<HelpDetails | null> => {
  const cached = helpDetailsCache.get(helpId);
  if (cached) { return cached; }
  const request = GeneralComponentApi.gethelpdetails({ help_id: helpId })
    .then((response: Response) => (response.ok ? response.json() : null))
    .then((data: any) => (data && data.status === 1 ? toHelpDetails(data.data) : null))
    .catch(() => null)
    .then((details: HelpDetails | null) => {
      if (!details) { helpDetailsCache.delete(helpId); }
      return details;
    });
  helpDetailsCache.set(helpId, request);
  return request;
};

// Many help ids in one request; shares the single-id cache, so ids already loaded are not fetched again.
export const loadHelpDetailsBulk = (helpIds: number[]): Promise<Record<number, HelpDetails>> => {
  const missing = helpIds.filter((id) => !helpDetailsCache.has(id));
  if (missing.length > 0) {
    const request = GeneralComponentApi.gethelpdetails({ help_ids: missing.join(',') })
      .then((response: Response) => (response.ok ? response.json() : null))
      .then((data: any) => (data && data.status === 1 && data.data ? data.data : {}))
      .catch(() => ({}));
    missing.forEach((id) => {
      helpDetailsCache.set(id, request.then((rows: any) => {
        const details = toHelpDetails(rows[id]);
        if (!details) { helpDetailsCache.delete(id); }
        return details;
      }));
    });
  }
  return Promise.all(helpIds.map((id) => helpDetailsCache.get(id) as Promise<HelpDetails | null>)).then((list) => {
    const out: Record<number, HelpDetails> = {};
    helpIds.forEach((id, i) => { const d = list[i]; if (d) { out[id] = d; } });
    return out;
  });
};

// Same video lightbox the click popup used, opened from the URL so it works after the card closes.
const openHelpVideo = (videoLink: string) => {
  ($ as any).magnificPopup.open({
    items: { src: videoLink },
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function () {
        $('.mfp-wrap').css('z-index', '99999999999');
        $('.mfp-bg').css('z-index', '99999999999');
      },
    },
  });
};

function HelpTipContent({ helpId }: { helpId: number }) {
  const [details, setDetails] = useState<HelpDetails | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    loadHelpDetails(helpId).then((d) => {
      if (active) { setDetails(d); setLoading(false); }
    });
    return () => { active = false; };
  }, [helpId]);
  if (loading) { return <Text size="sm" color="dimmed">Loading…</Text>; }
  if (!details) { return <Text size="sm" color="dimmed">No help text yet.</Text>; }
  return (
    <>
      {details.title !== '' && <Text size="md" weight={600} mb={6}>{details.title}</Text>}
      <Text className="visi-help-html" size="sm" sx={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: details.text }} />
      {details.videoLink !== '' && (
        <Button size="xs" fullWidth mt="sm" style={{ backgroundColor: '#c82333', color: '#fff' }} onClick={() => openHelpVideo(details.videoLink)}>
          Watch video tutorial
        </Button>
      )}
      <Flex justify="center" mt="xs">
        <Link className="visi-help-link" to="https://visiopt.com/help-videos.html" target="_blank" style={{ textDecoration: 'underline', fontSize: 14 }}>
          Click Here To Reach Our Help Library
        </Link>
      </Flex>
    </>
  );
}

// App-wide help ⓘ: opens on hover (and tap) and stays open while the pointer is over the card, so its buttons and links can be clicked.
// `content` swaps the single help entry for a custom panel (e.g. a section's metric list).
// Content is capped at half the viewport so it always fits above or below the icon; longer content scrolls.
export function HelpTip({ helpId, label = 'Help', zIndex = 10000, content, width = 360 }: { helpId?: number; label?: string; zIndex?: number; content?: ReactNode; width?: number }) {
  const [opened, setOpened] = useState(false);
  return (
    <HoverCard width={width} shadow="md" withArrow withinPortal position="bottom-start" openDelay={100} closeDelay={150} zIndex={zIndex} onOpen={() => setOpened(true)}>
      <HoverCard.Target>
        <UnstyledButton
          aria-label={label}
          onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
          sx={(t) => ({
            display: 'inline-block',
            verticalAlign: 'middle',
            alignSelf: 'center',
            flex: '0 0 auto',
            marginLeft: 8,
            marginBottom: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            border: `1px solid ${t.colorScheme === 'dark' ? t.colors.dark[2] : t.colors.gray[4]}`,
            color: t.colorScheme === 'dark' ? t.colors.dark[0] : '#333536',
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            fontWeight: 600,
            fontSize: 12,
            lineHeight: '16px',
            textAlign: 'center',
            cursor: 'help',
          })}
        >
          i
        </UnstyledButton>
      </HoverCard.Target>
      <HoverCard.Dropdown sx={{ maxWidth: 'calc(100vw - 32px)' }}>
        <Box
          sx={(t) => ({
            maxHeight: 'calc(50vh - 56px)',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            paddingRight: 4,
            '& .visi-help-link': { color: t.colorScheme === 'dark' ? t.colors.blue[4] : '#0056b3' },
            // Admin-authored HTML can carry inline light-theme colours; let it follow the dark theme instead.
            ...(t.colorScheme === 'dark' ? {
              '& .visi-help-html *': { color: 'inherit !important', backgroundColor: 'transparent !important' },
              '& .visi-help-html a': { color: `${t.colors.blue[4]} !important` },
            } : {}),
          })}
        >
          {opened && (content ?? (helpId !== undefined ? <HelpTipContent helpId={helpId} /> : null))}
        </Box>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

export function useColorScheme() {
  const [colorScheme, setColorScheme] = useState(localStorage.getItem("visicolorscheme") !== null ? localStorage.getItem("visicolorscheme") : 'light');

  useEffect(() => {
    const updateColorScheme = () => {
      const newScheme = localStorage.getItem("visicolorscheme");
      setColorScheme(newScheme);
    };

    const handleStorageEvent = (event) => {
      if (event.key === "visicolorscheme") {
        updateColorScheme();
      }
    };

    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      const result = originalSetItem.apply(this, arguments);
      if (key === "visicolorscheme") {
        window.dispatchEvent(new Event("visicolorscheme-change"));
      }
      return result;
    };

    window.addEventListener("storage", handleStorageEvent);
    window.addEventListener("visicolorscheme-change", updateColorScheme);

    return () => {
      window.removeEventListener("storage", handleStorageEvent);
      window.removeEventListener("visicolorscheme-change", updateColorScheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  return colorScheme;
}

export function ReportChartStyle() {

  const colorTheme = useColorScheme();
  return(
    <>
      <div
        style={{
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          border: "1px dashed",
          borderColor: colorTheme === "light" ? "#ccc" : "#555",
          borderRadius: "8px",
          background: colorTheme === "light" ? "#fafafa" : "#2c2c2c",
          fontSize: "16px",
          color: colorTheme === "light" ? "#666" : "#ddd",
          marginTop: "10px",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            colorTheme === "light" ? "#f0f0f0" : "#3a3a3a";
          e.currentTarget.style.borderColor =
            colorTheme === "light" ? "#999" : "#777";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            colorTheme === "light" ? "#fafafa" : "#2c2c2c";
          e.currentTarget.style.borderColor =
            colorTheme === "light" ? "#ccc" : "#555";
        }}
      >
        📊 No data available
        <div style={{ fontSize: "12px", marginTop: "4px", opacity: 0.8 }}>
          Please adjust filters or date range
        </div>
      </div>
    </>
  );
};

// The page saved fine but the page list could not be pushed to the wordpress plugin, warn and offer a retry
export function showWpSyncWarning(APIResultJSON:any, websiteId:any) {
  const data = APIResultJSON && APIResultJSON.data ? APIResultJSON.data : {};
  if(data.wp_sync_status !== 0 || !data.wp_sync_message){
    return;
  }
  const notificationId = 'wp-sync-warning';
  const handleResync = () => {
    SettingsApi.resyncwppages({ website_id: websiteId })
      .then(res => res.json())
      .then(res => {
        notifications.hide(notificationId);
        notifications.show({
          color: res.status === 1 ? 'green' : 'yellow',
          icon: res.status === 1 ? <IconCheck size="1.1rem" /> : <IconAlertTriangle size="1.1rem" />,
          title: res.status === 1 ? 'Success' : 'WordPress not updated',
          message: res.message,
          autoClose: res.status === 1 ? 4000 : false,
        });
      })
      .catch(() => {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: 'Network error occurred',
        });
      });
  };
  notifications.show({
    id: notificationId,
    color: 'yellow',
    icon: <IconAlertTriangle size="1.1rem" />,
    title: 'WordPress not updated',
    autoClose: false,
    message: (
      <>
        <Text size="sm">{data.wp_sync_message}</Text>
        <Button size="xs" mt="xs" variant="light" color="yellow" onClick={handleResync}>Re-sync WordPress</Button>
      </>
    ),
  });
}

export function UpdateMessages({updateMessages, updateMessageModel, setUpdateMessagesModel}:any) {


  const handleClose = () => {
    setUpdateMessagesModel(false);
  };


  return(
    <>
      <Modal.Root opened={updateMessageModel} onClose={handleClose} size="60%" trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>VISIOPT UPDATES <HelpTip helpId={184} /></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <ScrollArea h={320} type="always">
              <Stack spacing="md">
                {updateMessages.map((element, index) => (
                  <Box
                    key={index}
                    style={{
                      maxWidth: 1200,
                      backgroundColor: "#f8f9fa",
                      padding: "12px",
                      borderRadius: "6px",
                    }}
                  >
                    <Group position="apart" align="flex-start">
                      <Text fw={500} fz={18}>{element.message_title}</Text>
                      <Text size="sm" c="gray">{element.created_date}</Text>
                    </Group>
                    <Text size="sm" mt="xs" dangerouslySetInnerHTML={{ __html: element.message_text }} fz="sm"></Text>
                  </Box>
                ))}
              </Stack>
            </ScrollArea>
            <Group position="right" mt="lg"> 
              <Button color="red" onClick={handleClose}>Close</Button>
            </Group>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};